export class servicesData {
    static calculator = {
        images: [
            {
                img: "assets/images/saas1/calculator/1.jpg"
            },
            {
                img: "assets/images/saas1/calculator/2.png"
            },
            {
                img: "assets/images/saas1/calculator/3.jpeg"
            },
            {
                img: "assets/images/saas1/calculator/4.jpg"
            },
            {
                img: "assets/images/saas1/calculator/5.jpg"
            },
            {
                img: "assets/images/saas1/calculator/6.jpg"
            }
        ],
        navsync: [
            {
                data: 'About first step'
            },
            {
                data: 'About second step'
            },
            {
                data: 'About third'
            },
            {
                data: 'About fourth'
            },
            {
                data: 'About fifth'
            },
            {
                data: 'About sixth'
            }
        ]
    }
    static maintenance =
        {
            images: [
                {
                    img: "assets/images/saas1/maintenance/1.jpg"
                },
                {
                    img: "assets/images/saas1/maintenance/2.png"
                },
                {
                    img: "assets/images/saas1/maintenance/3.jpeg"
                },
                {
                    img: "assets/images/saas1/maintenance/4.jpg"
                },
                {
                    img: "assets/images/saas1/maintenance/5.jpg"
                },
                {
                    img: "assets/images/saas1/maintenance/6.jpg"
                }
            ],
            navsync: [
                {
                    data: 'About first step'
                },
                {
                    data: 'About second step'
                },
                {
                    data: 'About third'
                },
                {
                    data: 'About fourth'
                },
                {
                    data: 'About fifth'
                },
                {
                    data: 'About sixth'
                }
            ]
        }
    static datascience =
        {
            images: [
                {
                    img: "assets/images/saas1/datascience/1.jpg"
                },
                {
                    img: "assets/images/saas1/datascience/2.jpg"
                },
                {
                    img: "assets/images/saas1/datascience/3.jpg"
                },
                {
                    img: "assets/images/saas1/datascience/4.jpg"
                },
                {
                    img: "assets/images/saas1/datascience/5.jpg"
                },
                {
                    img: "assets/images/saas1/datascience/6.jpg"
                }
            ],
            navsync: [
                {
                    data: 'About first step'
                },
                {
                    data: 'About second step'
                },
                {
                    data: 'About third'
                },
                {
                    data: 'About fourth'
                },
                {
                    data: 'About fifth'
                },
                {
                    data: 'About sixth'
                }
            ]
        }
    static development =
        {
            images: [
                {
                    img: "assets/images/saas1/development/1.jpg"
                },
                {
                    img: "assets/images/saas1/development/2.png"
                },
                {
                    img: "assets/images/saas1/development/3.jpeg"
                },
                {
                    img: "assets/images/saas1/development/4.jpg"
                },
                {
                    img: "assets/images/saas1/development/5.jpg"
                },
                {
                    img: "assets/images/saas1/development/6.jpg"
                }
            ],
            navsync: [
                {
                    data: 'About first step'
                },
                {
                    data: 'About second step'
                },
                {
                    data: 'About third'
                },
                {
                    data: 'About fourth'
                },
                {
                    data: 'About fifth'
                },
                {
                    data: 'About sixth'
                }
            ]
        }

    static enterprise =
        {
            images: [
                {
                    img: "assets/images/saas1/enterprise/1.jpg"
                },
                {
                    img: "assets/images/saas1/enterprise/2.png"
                },
                {
                    img: "assets/images/saas1/enterprise/3.jpeg"
                },
                {
                    img: "assets/images/saas1/enterprise/4.jpg"
                },
                {
                    img: "assets/images/saas1/enterprise/5.jpg"
                },
                {
                    img: "assets/images/saas1/enterprise/6.jpg"
                }
            ],
            navsync: [
                {
                    data: 'About first step'
                },
                {
                    data: 'About second step'
                },
                {
                    data: 'About third'
                },
                {
                    data: 'About fourth'
                },
                {
                    data: 'About fifth'
                },
                {
                    data: 'About sixth'
                }
            ]
        }
    static optimization =
        {
            images: [
                {
                    img: "assets/images/saas1/optimization/1.jpg"
                },
                {
                    img: "assets/images/saas1/optimization/2.png"
                },
                {
                    img: "assets/images/saas1/optimization/3.jpeg"
                },
                {
                    img: "assets/images/saas1/optimization/4.jpg"
                },
                {
                    img: "assets/images/saas1/optimization/5.jpg"
                },
                {
                    img: "assets/images/saas1/optimization/6.jpg"
                }
            ],
            navsync: [
                {
                    data: 'About first step'
                },
                {
                    data: 'About second step'
                },
                {
                    data: 'About third'
                },
                {
                    data: 'About fourth'
                },
                {
                    data: 'About fifth'
                },
                {
                    data: 'About sixth'
                }
            ]
        }

}